import { Outlet } from 'react-router-dom'
import useAuth from '../../usecases/useAuth'
import Spinner from '../atoms/Spinner'

const Private = () => {
  const { isLoadingProfile } = useAuth()

  return (
    <>
      <Spinner spinning={isLoadingProfile}>
        <Outlet />
      </Spinner>
    </>
  )
}

export default Private
